import axios from 'axios'
import settings from '../../settings'
const stories = {
    namespaced: true,
    state: () => ({
        count: 0,
        all:[],
        search:[]
      }),
      mutations:{
         updateStoriesState(state,data){
             state.all=data;
         },
         updateSearchState(state,data){
             state.search=data;
         },
      },
      actions: {
        fetchStories({commit},{page=1}){
            axios.get(`${settings.apiUrl}/stories?page=${page}`).then(res => {
					commit('updateStoriesState',res.data)
			 });
        },
        search({commit},query){
            axios.get(`${settings.apiUrl}/stories?search=${query}`).then(res => {
				 	commit('updateSearchState',res.data)
			 });
        },
      },
    
      getters: {
           
      }
}

export default stories;

 